import { Email } from "@mui/icons-material";
import Person2Icon from '@mui/icons-material/Person2';
import LibraryBooksIcon from '@mui/icons-material/LibraryBooks';
import FavoriteIcon from '@mui/icons-material/Favorite';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import StarIcon from '@mui/icons-material/Star';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import PaidIcon from '@mui/icons-material/Paid';
import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremium';
import HelpIcon from '@mui/icons-material/Help';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import EditIcon from '@mui/icons-material/Edit';
import SmartToyIcon from '@mui/icons-material/SmartToy';
import PollIcon from '@mui/icons-material/Poll';
import ImportExportIcon from '@mui/icons-material/ImportExport';
import WorkspacePremium from "@mui/icons-material/WorkspacePremium";
import NotificationsIcon from '@mui/icons-material/Notifications';

export enum SeccionesPerfil {
    DEFAULT = 'default',
    MENSAJES = 'mensajes',
    MIS_LIBROS = 'mis-libros',
    IMPORTAR_EXPORTAR = 'importar-exportar',
    FAVORITOS = 'favoritos',
    MIS_COMPRAS = 'mis-compras',
    AJUSTES_PERFIL = 'perfil',
    PUNTUACIONES = 'puntuaciones',
    ESTADISTICAS = 'estadisticas',
    LOGROS = 'logros',
    RANKING = 'ranking',
    ALERTAS = 'alertas',
    CONSEGUIR_CREDITOS = 'conseguir-creditos',
    PREMIUM = 'premium',
    AYUDA = 'ayuda',
    CHAT_AYUDA = 'chat-ayuda',
    MIS_PUNTUACIONES_LIBROS = 'mis-puntuaciones-libros',
    CERRAR_SESION = 'cerrar-sesion',
}

export interface MenuPerfil {
    id: number;
    titulo: string;
    subtitulo: string;
    icono: JSX.Element;
    clave_seccion: SeccionesPerfil;
    notificaciones?: number;
}

export const menuCuenta: MenuPerfil[] = [
    {
        id: 5,
        titulo: "menu:secciones.ajustes_perfil.titulo",
        subtitulo: "menu:secciones.ajustes_perfil.descripcion",
        icono: <Person2Icon style={{ width: "35px", height: "35px" }} />,
        clave_seccion: SeccionesPerfil.AJUSTES_PERFIL
    },
    {
        id: 1,
        titulo: "menu:secciones.mensajes.titulo",
        subtitulo: "menu:secciones.mensajes.descripcion",
        icono: <Email style={{ width: "35px", height: "35px" }} />,
        clave_seccion: SeccionesPerfil.MENSAJES
    },
    {
        id: 2,
        titulo: "menu:secciones.mis_libros.titulo",
        subtitulo: "menu:secciones.mis_libros.descripcion",
        icono: <LibraryBooksIcon style={{ width: "35px", height: "35px" }} />,
        clave_seccion: SeccionesPerfil.MIS_LIBROS
    },
    {
        id: 14,
        titulo: "menu:secciones.importar_exportar.titulo",
        subtitulo: "menu:secciones.importar_exportar.descripcion",
        icono: <ImportExportIcon style={{ width: "35px", height: "35px" }} />,
        clave_seccion: SeccionesPerfil.IMPORTAR_EXPORTAR
    },
    {
        id: 3,
        titulo: "menu:secciones.favoritos.titulo",
        subtitulo: "menu:secciones.favoritos.descripcion",
        icono: <FavoriteIcon style={{ width: "35px", height: "35px" }} />,
        clave_seccion: SeccionesPerfil.FAVORITOS
    },
    {
        id: 4,
        titulo: "menu:secciones.mis_compras.titulo",
        subtitulo: "menu:secciones.mis_compras.descripcion",
        icono: <ShoppingCartIcon style={{ width: "35px", height: "35px" }} />,
        clave_seccion: SeccionesPerfil.MIS_COMPRAS
    }
]

export const menuActividad: MenuPerfil[] = [
    {
        id: 9,
        titulo: "menu:secciones.premium.titulo",
        subtitulo: "menu:secciones.premium.descripcion",
        icono: <WorkspacePremiumIcon style={{ width: "35px", height: "35px" }} />,
        clave_seccion: SeccionesPerfil.PREMIUM
    },
    {
        id: 8,
        titulo: "menu:secciones.conseguir_creditos.titulo",
        subtitulo: "menu:secciones.conseguir_creditos.descripcion",
        icono: <PaidIcon style={{ width: "35px", height: "35px" }} />,
        clave_seccion: SeccionesPerfil.CONSEGUIR_CREDITOS
    },
    {
        id: 16,
        titulo: "menu:secciones.alertas.titulo",
        subtitulo: "menu:secciones.alertas.descripcion",
        icono: <NotificationsIcon style={{ width: "35px", height: "35px" }} />,
        clave_seccion: SeccionesPerfil.ALERTAS
    },
    {
        id: 6,
        titulo: "menu:secciones.estadisticas.titulo",
        subtitulo: "menu:secciones.estadisticas.descripcion",
        icono: <PollIcon style={{ width: "35px", height: "35px" }} />,
        clave_seccion: SeccionesPerfil.ESTADISTICAS
    },
    {
        id: 6,
        titulo: "menu:secciones.puntuaciones.titulo",
        subtitulo: "menu:secciones.puntuaciones.descripcion",
        icono: <StarIcon style={{ width: "35px", height: "35px" }} />,
        clave_seccion: SeccionesPerfil.PUNTUACIONES
    },
    {
        id: 13,
        titulo: "menu:secciones.puntuaciones_libros.titulo",
        subtitulo: "menu:secciones.puntuaciones_libros.descripcion",
        icono: <EditIcon style={{ width: "35px", height: "35px" }} />,
        clave_seccion: SeccionesPerfil.MIS_PUNTUACIONES_LIBROS
    },
    {
        id: 7,
        titulo: "menu:secciones.logros.titulo",
        subtitulo: "menu:secciones.logros.descripcion",
        icono: <WorkspacePremium style={{ width: "35px", height: "35px" }} />,
        clave_seccion: SeccionesPerfil.LOGROS
    },
    {
        id: 15,
        titulo: "menu:secciones.ranking.titulo",
        subtitulo: "menu:secciones.ranking.descripcion",
        icono: <EmojiEventsIcon style={{ width: "35px", height: "35px" }} />,
        clave_seccion: SeccionesPerfil.RANKING
    }

]

export const menuOtros: MenuPerfil[] = [
    {
        id: 10,
        titulo: "menu:secciones.ayuda.titulo",
        subtitulo: "menu:secciones.ayuda.descripcion",
        icono: <HelpIcon style={{ width: "35px", height: "35px" }} />,
        clave_seccion: SeccionesPerfil.AYUDA
    },
    {
        id: 11,
        titulo: "menu:secciones.chat_ayuda.titulo",
        subtitulo: "menu:secciones.chat_ayuda.descripcion",
        icono: <SmartToyIcon style={{ width: "35px", height: "35px" }} />,
        clave_seccion: SeccionesPerfil.CHAT_AYUDA
    },
    {
        id: 12,
        titulo: "menu:secciones.cerrar_sesion.titulo",
        subtitulo: "menu:secciones.cerrar_sesion.descripcion",
        icono: <ExitToAppIcon style={{ width: "35px", height: "35px" }} />,
        clave_seccion: SeccionesPerfil.CERRAR_SESION
    }
]

export interface OpcionTopNavigation {
    nombre: string;
    icono?: JSX.Element;
    tipoOpcion: any;
}

export enum MenuMensajeOption {
    MENSAJES = "mensajes",
    NOTIFICACIONES = "notificaciones"
}

export enum MenuEstadisticasOption {
    PROPIAS = "propias",
    GENERALES = "generales"
}
